import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import { Slider } from '../../primitives/slider';
import { DeprecatedText } from '../../deprecated-typography';
import { namespacedClassnames } from '../../common';
var sliderWithLabelsKey = 'slide-with-labels';
var SliderWithLabels = /** @class */ (function (_super) {
    __extends(SliderWithLabels, _super);
    function SliderWithLabels() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SliderWithLabels.prototype.render = function () {
        var _a = this.props, leftLabel = _a.leftLabel, rightLabel = _a.rightLabel, sliderProps = __rest(_a, ["leftLabel", "rightLabel"]);
        var classNames = namespacedClassnames(sliderWithLabelsKey);
        return (React.createElement("div", { className: classNames },
            React.createElement(Slider, __assign({}, sliderProps)),
            React.createElement("div", { className: 'slider-labels' },
                React.createElement(DeprecatedText, { type: 't4b' }, leftLabel),
                React.createElement(DeprecatedText, { type: 't4b' }, rightLabel))));
    };
    return SliderWithLabels;
}(React.PureComponent));
export { SliderWithLabels };
//# sourceMappingURL=index.js.map